import { render, staticRenderFns } from "./marshall_warnings.vue?vue&type=template&id=30513ba6&scoped=true"
import script from "./marshall_warnings.vue?vue&type=script&lang=js"
export * from "./marshall_warnings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30513ba6",
  null
  
)

export default component.exports